
const helper = {
  getFaceIdFromFirestoreUrl: function (url) {
    // @todo: is the '/o/' in appspot.com/o/ sticking around?
    // Why are our path deliminators %2F instead of / ?
    // Should match thumbs or apng if nothing changes
    var re = /(?:appspot\.com\/o\/[A-Za-z]*%2F)(.*)(?:\?)/
    var matches = url.match(re)
    if (matches) {
      return matches[1]
    }
    return null
  },
  getTokenFromFirestoreUrl: function (url) {
    var re = /(?:token=)(.*)/
    var matches = url.match(re)
    if (matches) {
      return matches[1]
    }
    return null
  },
  downloadExistingFile (urlToFile, success, failure) {
    var xhr = new XMLHttpRequest()
    xhr.responseType = 'arraybuffer'
    xhr.open('GET', urlToFile)

    xhr.onload = function (e) {
      if (xhr.status !== '404') {
        if (success) success(xhr.response)
      } else if (failure) failure('That file was not found.')
    }
    xhr.onerror = function () {
      if (failure) {
        failure(
          'Error loading gif. Make sure the resource exists and has Access-Control-Allow-Origin headers.'
        )
      }
    }
    xhr.send()
  },
  isLocalStorageAvailable () {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('feature_test', 'yes')
        if (localStorage.getItem('feature_test') === 'yes') {
          localStorage.removeItem('feature_test')
          return true
        }
      }
      return false
    } catch (e) {
      return false
    }
  },
  isTTSAvailable () {
    if (typeof speechSynthesis !== 'undefined') {
      return true
    }
    return false
  },
  isBrowserCompatible () {
    return this.isLocalStorageAvailable() && this.isTTSAvailable()
  },
  doesFileExist (urlToFile, success, failure) {
    var xhr = new XMLHttpRequest()
    xhr.open('HEAD', urlToFile, true)
    xhr.onload = function (e) {
      if (xhr.status !== '404') {
        if (success) success(urlToFile)
      } else {
        if (failure) failure('That file was not found.')
        this.fileFailed = true
      }
    }
    xhr.onerror = function (e) {
      if (failure) {
        failure(
          'Error loading gif. Make sure the resource exists and has Access-Control-Allow-Origin headers.'
        )
      }
    }
    xhr.send()
  }
}

export default helper



// WEBPACK FOOTER //
// ./src/helper/index.js